import { render } from "./RefundModal.vue?vue&type=template&id=bc87c9c4&scoped=true"
import script from "./RefundModal.vue?vue&type=script&lang=js"
export * from "./RefundModal.vue?vue&type=script&lang=js"

import "./RefundModal.vue?vue&type=style&index=0&id=bc87c9c4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc87c9c4"]])

export default __exports__